module.exports = __webpack_public_path__ + "static/media/money_bonus_3.5212b193.webp";